var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.9167H6.60345C6.4434 21.9167 6.28991 21.8552 6.17675 21.7458C6.06358 21.6364 6 21.488 6 21.3333C6 21.1786 6.06358 21.0303 6.17675 20.9209C6.28991 20.8115 6.4434 20.75 6.60345 20.75H23.5C23.66 20.75 23.8135 20.8115 23.9267 20.9209C24.0399 21.0303 24.1034 21.1786 24.1034 21.3333C24.1034 21.488 24.0399 21.6364 23.9267 21.7458C23.8135 21.8552 23.66 21.9167 23.5 21.9167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16.0834H6.60345C6.4434 16.0834 6.28991 16.0219 6.17675 15.9125C6.06358 15.8031 6 15.6547 6 15.5C6 15.3453 6.06358 15.1969 6.17675 15.0875C6.28991 14.9781 6.4434 14.9167 6.60345 14.9167H23.5C23.66 14.9167 23.8135 14.9781 23.9267 15.0875C24.0399 15.1969 24.1034 15.3453 24.1034 15.5C24.1034 15.6547 24.0399 15.8031 23.9267 15.9125C23.8135 16.0219 23.66 16.0834 23.5 16.0834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10.25H6.60345C6.4434 10.25 6.28991 10.1885 6.17675 10.0791C6.06358 9.96973 6 9.82136 6 9.66665C6 9.51194 6.06358 9.36356 6.17675 9.25417C6.28991 9.14477 6.4434 9.08331 6.60345 9.08331H23.5C23.66 9.08331 23.8135 9.14477 23.9267 9.25417C24.0399 9.36356 24.1034 9.51194 24.1034 9.66665C24.1034 9.82136 24.0399 9.96973 23.9267 10.0791C23.8135 10.1885 23.66 10.25 23.5 10.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.336dd97a141decd5890f86b89840938b.svg";
export { ForwardRef as ReactComponent };